// Utility functions for common inline style objects
// Use these across Vue components to keep styling consistent and DRY.

/**
 * Returns an inline style object with padding.
 * @param {string|number} value - Padding value (e.g., '15px', '1rem', 12). If number is provided, 'px' is assumed.
 * @returns {{ padding: string }}
 */
export const withPadding = (value = '15px') => {
  if (typeof value === 'number') {
    return { padding: `${value}px` };
  }
  return { padding: value };
};

/**
 * Generic helper to produce a style object with arbitrary CSS variable pairs.
 * @param {Record<string, string>} vars - Map of CSS variable names to values.
 * @returns {Record<string, string>} - Inline style object including CSS variables.
 */
export const withCssVars = (vars = {}) => ({ ...vars });
